/*
 * @Description: 登录页面的api
 * @Author: gao shuai
 * @Date: 2020-02-25 15:36:33
 * @LastEditTime: 2020-07-13 18:21:28
 * @LastEditors: gao shuai
 */
import api from '../services/api';
export default {
  // 获取用户分组
  async groupsdrow(params) {
  return api({ url: '/api/InstallPartition/GetGroups', method: 'get', params });
  },
  // 获取用户模板接口
  async modelDrow(params) {
  return api({ url: '/api/InstallPartition/GetTemplates', method: 'get', params });
  },
  // 安装分区
  async partInstall(params) {
  return api({ url: '/api/InstallPartition/Install', method: 'post', data: params });
  },
  // 编辑分区
  async partEdit(params) {
  return api({ url: '/api/InstallPartition/Edit', method: 'post', data: params });
  },
  // 获取服务器机器码
  async getMachineCode(params) {
  return api({ url: '/api/InstallPartition/GetMachineCode', method: 'get', params });
  },
  // 删除机器码
  async delMachineCode(params) {
  return api({ url: '/api/PartitionsManager/BatchDeleteMachineCodeAsync', method: 'post', data: params });
  }
};
